import { InstanceSVG } from '@sbercloud/uikit-product-icons';

export { InstanceSVG as Instance, InstanceSVG };
